import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "px-4 pt-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "text-xl" }, "Session Expired", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-700 mb-6" }, " Your session has timed out. Please re-enter your password to continue or sign into another account. ", -1)
const _hoisted_5 = { class: "my-4" }
const _hoisted_6 = { class: "flex flex-row justify-end px-2 py-4" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Login ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Form = _resolveComponent("Form")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    show: _ctx.showModal,
    "set-close": _ctx.setClose,
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_Form, {
            valid: _ctx.isValid,
            "onUpdate:valid": _cache[4] || (_cache[4] = $event => (_ctx.isValid = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                label: "Email",
                value: _ctx.form.email.value,
                "onUpdate:value": _cache[1] || (_cache[1] = $event => (_ctx.form.email.value = $event)),
                rules: _ctx.form.email.rules
              }, null, 8, ["value", "rules"]),
              _createVNode(_component_Input, {
                label: "Password",
                type: "password",
                value: _ctx.form.password.value,
                "onUpdate:value": _cache[2] || (_cache[2] = $event => (_ctx.form.password.value = $event)),
                rules: _ctx.form.password.rules
              }, null, 8, ["value", "rules"]),
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_Checkbox, {
                  label: "Remember Me",
                  value: _ctx.form.rememberMe.value,
                  "onUpdate:value": _cache[3] || (_cache[3] = $event => (_ctx.form.rememberMe.value = $event))
                }, null, 8, ["value"])
              ])
            ]),
            _: 1
          }, 8, ["valid"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            color: "secondary",
            "is-disabled": !_ctx.isValid,
            onClick: _cache[5] || (_cache[5] = $event => (_ctx.login()))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["is-disabled"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show", "set-close"]))
}